export function GenericNotFound({
  redirectURL,
  shouldRedirect = true,
}: {
  redirectURL?: string
  // shouldRedirect gives more control to the consuming application
  // if they want to handle the redirect themselves
  shouldRedirect?: boolean
}) {
  if (shouldRedirect) {
    setTimeout(() => {
      const hostUrl = `${window.location.protocol}//${window.location.hostname}`

      window.location.href = redirectURL ? redirectURL : hostUrl
    }, 3000)
  }

  return (
    <div className='dc-shared-web tw-h-full tw-w-full'>
      <div className='tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full'>
        <div className='tw-space-y-2 tw-text-center tw-mx-auto'>
          <div className='tw-font-semibold'>404 Page not found</div>
          <div>The page you are trying to view doesn&apos;t exist.</div>
          <div>You will now be redirected.</div>
        </div>
      </div>
    </div>
  )
}
